import Model from './model.js';

class Chart{
    constructor(data){
        this.colorsH = ['#74788d', '#556ee6', '#34c38f', '#50a5f1'];
        this.colorsC = ['secondary', 'primary', 'success', 'info'];
        
        this.series = data.series;
        this.list = [];
        
        this.chartOptions = {
            labels: data.labels,
            colors: this.colorsH.slice(1, data.labels.length + 1),
            legend: {
                show: false,
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: '57%',
                    }
                }
            }
        }
    }
}

export default class Ststistic extends Model
{
    constructor(ststistic){
        super()
        this.admins      = ''
        this.attachments = ''
        this.videos      = ''
        this.links       = ''
        this.images      = ''

        this.charts      = {}

        this.map(ststistic)
        this.init()
    }

    map(ststistic){
        if(ststistic == undefined) return
        this.admins     = ststistic.admins
        this.attachments= ststistic.attachments
        this.videos     = ststistic.videos
        this.links      = ststistic.links
        this.images     = ststistic.images

        this.charts.post = new Chart({
            series: Object.values(ststistic.charts.post),
            labels: [' المنشورة ', ' غير المنشورة '],
        });
        this.charts.post.list =  {
            labels: ['كل الاخبار', ...this.charts.post.chartOptions.labels],
            count : [this.charts.post.series.reduce((a,b)=>a+b, 0), ...this.charts.post.series],
            colors: this.charts.post.colorsC.slice(0, this.charts.post.chartOptions.labels.length + 1)
        }

        this.charts.image = new Chart({
            series: ststistic.charts.image.map((x)=>x.images_count),
            labels: ststistic.charts.image.map((x)=>x.title),
        });
        this.charts.image.list =  {
            labels: ['كل الصور', ...this.charts.image.chartOptions.labels],
            count : [this.charts.image.series.reduce((a,b)=>a+b, 0), ...this.charts.image.series],
            colors: this.charts.image.colorsC.slice(0, this.charts.image.chartOptions.labels.length + 1)
        }
    }
}